import React from 'react'
import { Tooltip } from 'shared/ui'
import { spam as SpamIcon } from 'assets/icons/groove/v2'

const SpamButton = React.memo(({ spamConversation }) => {
  return (
    <div className="spam">
      <Tooltip position="bottom" tooltip={'Spam [!]'}>
        <a className="menu-button" onClick={spamConversation}>
          <SpamIcon />
        </a>
      </Tooltip>
    </div>
  )
})

export default SpamButton
